import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=79e058d5&scoped=true"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=79e058d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e058d5",
  null
  
)

export default component.exports